import script from "./AdminPendingEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPendingEvents.vue?vue&type=script&setup=true&lang=js"

import "./AdminPendingEvents.vue?vue&type=style&index=0&id=7e2aa17c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2aa17c"]])

export default __exports__